const STORAGE_KEY = "floatingWindowsShowChrome";

export function carregarBordasJanelas() {
  try {
    const salvo = localStorage.getItem(STORAGE_KEY);
    return salvo === null ? true : salvo === "true";
  } catch (error) {
    return true;
  }
}

export function salvarBordasJanelas(exibir) {
  try {
    localStorage.setItem(STORAGE_KEY, exibir ? "true" : "false");
  } catch (error) {
    // A preferência visual é opcional.
  }
}

export function eventoBordasJanelas(evento) {
  return evento && evento.key === STORAGE_KEY;
}
